<template>
  <div>
    <v-layout v-for="item in buttons" row :key="item.id" id="form-footer-icon">
      <v-tooltip top id="object-form-footer-tooltip">
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            @click="executeAction(item.id)"
            x-small
            fab
            class="ma-0"
            color="F5F5F5"
          >
            <v-icon color="accent">
              {{ item.icon }}
            </v-icon>
          </v-btn>
        </template>

        <span class="object-form-footer-label">{{ item.label }}</span>
      </v-tooltip>
    </v-layout>
  </div>
</template>

<script>
import { bus } from "@/main";

export default {
  name: "ObjectFormFooter",

  props: {
    /**
     * Layer of selected object
     */
    layer: {
      type: String,
      required: true
    },

    /**
     * UUID of selected object
     */
    objectUuid: {
      type: String,
      required: true
    },

    /**
     * Coordinate of selected object
     */
    objectCoordinate: {
      type: String,
      required: true
    }
  },

  computed: {
    /**
     * Defines the available buttons in the forms footer
     * @returns {[{icon: string, id: string, label: VueI18n.TranslateResult}]}
     */
    buttons() {
      return [
        {
          id: "open-on-workspace",
          label: this.$i18n.t("OpenOnWorkspace"),
          icon: "filter_none"
        }
      ];
    }
  },

  methods: {
    /**
     * Whenever one of the buttons is clicked, it performs the intended action
     * @param id
     */
    executeAction(id) {
      switch (id) {
        case "open-on-workspace":
          this.openOnWorkspace();
          break;
      }
    },

    /**
     * Sends an event with the object's data, to be shown in a workspace where the object is contained
     * @returns {Promise<void>}
     */
    async openOnWorkspace() {
      bus.$emit("open-on-workspace", {
        uuid: this.objectUuid,
        layer: this.layer,
        coordinates: this.objectCoordinate
      });
    }
  }
};
</script>

<style scoped>
.object-form-footer-label {
  font: normal normal 600 10px/14px Segoe UI;
  color: #32383d;
}

.v-tooltip__content {
  background: #ffffff 0 0 no-repeat padding-box;
  box-shadow: 0 0 6px #00000029;
  border-radius: 5px;
  padding: 0 16px;
}
</style>
<style>
#form-footer-icon .v-btn--is-elevated.v-btn--fab {
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Network/Forms/_Molecules/ObjectFormFooter.vue